export const COOKIE_CONSENT_STORAGE_KEY = 'tenantscore_cookie_consent';
export const COOKIE_CONSENT_VERSION = 1;

export const readCookieConsent = () => {
  try {
    const raw = localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    if (parsed?.version !== COOKIE_CONSENT_VERSION) return null;
    if (parsed?.analytics !== true && parsed?.analytics !== false) return null;

    return parsed;
  } catch {
    return null;
  }
};

export const writeCookieConsent = ({ analytics }) => {
  const value = {
    version: COOKIE_CONSENT_VERSION,
    analytics: Boolean(analytics),
    updatedAt: new Date().toISOString(),
  };

  try {
    localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, JSON.stringify(value));
  } catch {
    // Ignore storage failures (private mode, quota, etc.)
  }

  return value;
};

export const hasAnalyticsConsent = () => readCookieConsent()?.analytics === true;
